/**
 * Deterministic seeded RNG (mulberry32). Procedural generation must be
 * reproducible from a seed so a given solar system always regenerates identically
 * (share codes, save/load, prestige seeds). ~2^32 period — ample for layout.
 */
export interface RNG {
  next(): number; // [0,1)
  range(min: number, max: number): number; // [min,max)
  int(min: number, max: number): number; // integer [min,max]
  pick<T>(arr: readonly T[]): T;
}

export function makeRng(seed: number): RNG {
  let a = seed >>> 0;
  const next = (): number => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    range: (min, max) => min + next() * (max - min),
    int: (min, max) => Math.floor(min + next() * (max - min + 1)),
    pick: (arr) => arr[Math.floor(next() * arr.length)] as (typeof arr)[number],
  };
}
